import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {DevelopmentComponent} from './development.component';
import {DevelopmentRoutesComponent} from './routes/routes.component';

export const DevelopmentRoutes: Routes = [
  {
    path: '',
    component: DevelopmentComponent,
    children: [
      {
        path: 'rotas',
        component: DevelopmentRoutesComponent
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/404'
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(DevelopmentRoutes)
  ],
  exports: [RouterModule]
})

export class DevelopmentRoutingModule {}
